"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimedPassthruRateLimiter = void 0;
var tslib_1 = require("tslib");
var TimeBasedRateLimiter_1 = require("./TimeBasedRateLimiter");
var TimedPassthruRateLimiter = /** @class */ (function (_super) {
    tslib_1.__extends(TimedPassthruRateLimiter, _super);
    function TimedPassthruRateLimiter(child, config) {
        return _super.call(this, tslib_1.__assign(tslib_1.__assign({}, config), { doRequest: function (req) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, child.request(req)];
                    });
                });
            } })) || this;
    }
    return TimedPassthruRateLimiter;
}(TimeBasedRateLimiter_1.TimeBasedRateLimiter));
exports.TimedPassthruRateLimiter = TimedPassthruRateLimiter;
//# sourceMappingURL=TimedPassthruRateLimiter.js.map